/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { type License, LicenseState } from '@dm/core';
import { LicenseValue } from 'app/feature/settings/license-management/license-management.service';

import { LicenseKey } from './license-key';

/**
 * /hardware_feature/active_hardware_feature接口返回的硬件管控特性的key
 */
export enum HardwareFeatureKeyE {
    /**
     * 安全卡
     */
    SECURITY_MODULE_FEATURE = 'securityModuleFeature',
    /**
     * 安全卡信息
     */
    SECURITY_MODULE_INFO = 'securityModuleinfo'
}

/**
 * 虚拟防勒索license
 */
export const virtualAntiRansomware: License = {
    id: Number(LicenseValue.AntiRansomwareLicense),
    name: LicenseKey.AntiRansomware,
    // 展示名称在外层赋值
    displayName: '',
    state: LicenseState.valid,
};


/**
 * 硬件特性名称与该硬件信息映射表
 */
export const hardwareFeatureAndInfoMap = {
    /**
     * 安全卡
     */
    [HardwareFeatureKeyE.SECURITY_MODULE_FEATURE]: HardwareFeatureKeyE.SECURITY_MODULE_INFO,
};

/**
 * 硬件管控的license特性映射表（有硬件时，对应license管理的特性均有效）
 */
export const hardwareEqualToLicenseMap = { };
